<template>
  <div class="paper-manage-wrapper">
    <paper-list v-show="!showDataMigration && !isSetting" @defaultSetting="changeComponent" @get-migration="getMigrationData"></paper-list>
    <default-edit v-if="isSetting" :isPaper="true" :paperObj="settingItem" @goBack="changeComponent"></default-edit>
    <data-migration v-if="showDataMigration" @goBack="getMigrationData" :dataMigrationItem="dataMigrationItem" />
  </div>
</template>
<script>
import DefaultEdit from '@components/DefaultEdit'
import PaperList from './components/PaperList.vue'
import dataMigration from '@components/PaperManagement/components/DataMigration'

export default {
  name: 'paperManagement',
  data() {
    return {
      totalCount: 0,
      currentPageNo: 0,
      tableData: [
        {
          name: '北京日报',
          publishCount: 30,
          updateTime: '2022-11-22 09:49:19',
          updateContent: '北京日报2022年11月4日'
        },
        {
          name: '北京晚报',
          publishCount: 30,
          updateTime: '2022-11-22 09:49:19',
          updateContent: '北京日报2022年11月4日'
        }
      ],
      settingItem: null,
      isSetting: false,
      showDataMigration: false,
      dataMigrationItem: null
    }
  },
  methods: {
    changeComponent(item) {
      this.isSetting = !this.isSetting
      this.settingItem = item
    },
    getMigrationData(item) {
      this.showDataMigration = !this.showDataMigration
      this.dataMigrationItem = item
    }
  },
  components: {
    DefaultEdit,
    PaperList,
    dataMigration
  }
}
</script>
